<section>
    <div class="row">
        <div class="offset-md-3 unauthorized-data">
            <img src="assets/images/401.jpg" />
        </div>
    </div>
</section>